const loadingImageWrapper = document.getElementById("js-loading-wrapper");
const errorWrapper = document.getElementById("js-error-wrapper");
const loadingImage = loadingImageWrapper.innerHTML;
const shippingInfoTags = document.querySelectorAll(".js-shipping-info");
const shippingPriceTag = document.querySelector(".shipping-price");

export function calculateTotals() {
  const subTotalTag = document.getElementById("cart-subtotal-amount");
  const subtotalAmount = subTotalTag.dataset.subtotalAmount;

  const shippingCostTag = document.querySelector(".shipping-price");
  const shippingCost = shippingCostTag.dataset.shippingCost;

  const totalTag = document.getElementById("cart-total-amount");

  // calculate total amount
  const totalAmount = (
    (parseFloat(subtotalAmount) +
      parseFloat(shippingCost)) /
    100
  ).toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  totalTag.innerText = subTotalTag.innerText[0] + " " + totalAmount;
}

// select resize function
function resizeSelect(select) {
  const fakeEl = document.querySelector("#fakeEl");
  const option = select.options[select.selectedIndex];

  // add dot at the end to of the string to add more space for calculated width
  fakeEl[0].innerHTML = option.text + ".";
  countrySelectTags.forEach(
    (el) => (el.style.width = fakeEl.getBoundingClientRect().width + "px")
  );
}

// set selected country, zip and province
const countries = {
  "Aland Islands": "AX 22100",
  Albania: "1001",
  Andorra: "AD500",
  Armenia: "0001",
  Austria: "1010",
  Belarus: "220030",
  Belgium: "1000",
  "Bosnia And Herzegovina": "71124",
  Bulgaria: "1000",
  Croatia: "10000",
  Cyprus: "1011",
  "Czech Republic": "12000",
  Denmark: "1700",
  Estonia: "10140",
  "Faroe Islands": "470",
  Finland: "00101",
  France: "75004",
  Georgia: "0112",
  Germany: "80339",
  Gibraltar: "GX11 1AA",
  Greece: "10551",
  Greenland: "3900",
  Guadeloupe: "97122",
  Guernsey: "GY1 2JU",
  Hungary: "1051",
  Iceland: "101",
  Ireland: ["D02 N725", "Dublin"],
  "Isle Of Man": "IM2 3ER",
  Italy: ["00187", "Roma"],
  Jersey: "JE2 4TQ",
  Kosovo: "40000",
  Latvia: "LV-1047",
  Liechtenstein: "9490",
  Lithuania: "01402",
  Luxembourg: "2346",
  Malta: "VLT 1175",
  Mayotte: "97640",
  "Moldova, Republic of": "2001",
  Monaco: "98000",
  Montenegro: "81000",
  Netherlands: "1012 RE",
  "North Macedonia": "1000",
  Norway: "0154",
  Poland: "00-372",
  Portugal: ["1100-416", "Lisboa"],
  Reunion: "97400",
  Romania: ["010288", "București"],
  "San Marino": "47893",
  Serbia: "11000",
  Slovakia: "811 02",
  Slovenia: "1000",
  Spain: ["28012", "Madrid"],
  "Svalbard And Jan Mayen": "9170",
  Sweden: "111 29",
  Switzerland: "8001",
  Turkey: "06490",
  Ukraine: "01030",
  "United Kingdom": "SE1 9QU",
  "Vatican City": "00120",
};

const countrySelectTags = document.querySelectorAll(
  ".delivery-country-selector"
);

// get country from local storage if not available use selected country
let selectedCountry = localStorage.getItem("shippingDest")
  ? localStorage.getItem("shippingDest")
  : countrySelectTags[0].options[countrySelectTags[0].selectedIndex].value;

// test if country has a province and select province
let selectedProvince =
  typeof countries[selectedCountry] === "object"
    ? countries[selectedCountry][1]
    : "";

// test if country has a province and select zip code
let selectedZip =
  typeof countries[selectedCountry] === "object"
    ? countries[selectedCountry][0]
    : countries[selectedCountry];

// set selected country in select options
countrySelectTags.forEach((select) => {
  Object.values(select.options).forEach((option) =>
    option.value === selectedCountry
      ? (option.selected = true)
      : (option.selected = false)
  );
  resizeSelect(select);
});

// add event listener to handle country change
countrySelectTags.forEach((el) => {
  el.addEventListener("change", (e) => {
    // assign selected values to variables
    selectedCountry = e.target.options[e.target.selectedIndex].value;

    // assign province when available
    selectedProvince =
      typeof countries[selectedCountry] === "object"
        ? countries[selectedCountry][1]
        : "";

    // assign zip code
    selectedZip =
      typeof countries[selectedCountry] === "object"
        ? countries[selectedCountry][0]
        : countries[selectedCountry];

    // store selection to local storage
    localStorage.setItem("shippingDest", selectedCountry);

    // set selected country in select options
    countrySelectTags.forEach((select) => {
      Object.values(select.options).forEach((option) =>
        option.value === selectedCountry
          ? (option.selected = true)
          : (option.selected = false)
      );
      resizeSelect(select);
    });

    proofShippingCost();
  });
});

// request shipping rate calculation
const prepareShippingRates = async () => {
  const shippingStatus = await fetch(
    window.Shopify.routes.root +
      `cart/prepare_shipping_rates.json?shipping_address%5Bzip%5D=${selectedZip}&shipping_address%5Bcountry%5D=${selectedCountry}&shipping_address%5Bprovince%5D=${selectedProvince}`,
    { method: "POST" }
  )
    .then((response) => response.json())
    .then((data) => {
      if (data === null) {
        // if prepare request is ok get shipping fees
        getShippingRates();
      } else if (data.zip) {
        document
          .querySelector(".js-default-shipping")
          .classList.remove("hidden");
        // if there is an error with zip code show message
        errorWrapper.innerHTML = data.zip[0];
        loadingImageWrapper.style.display = "none";
        errorWrapper.style.display = "block";
      } else if (data.province) {
        document
          .querySelector(".js-default-shipping")
          .classList.remove("hidden");
        // if there is an error with zip code show message
        errorWrapper.innerHTML = data.province[0];
        loadingImageWrapper.style.display = "none";
        errorWrapper.style.display = "block";
      } else if (data.country) {
        document
          .querySelector(".js-default-shipping")
          .classList.remove("hidden");
        // if there is an error with country name show message
        errorWrapper.innerHTML = data.country[0];
        loadingImageWrapper.style.display = "none";
        errorWrapper.style.display = "block";
      } else {
        // if there is an error because of no items in the cart
        return "noshipping";
      }
    });

  return shippingStatus;
};

// get calculated shipping rate
const getShippingRates = () => {
  fetch(
    window.Shopify.routes.root +
      `cart/async_shipping_rates.json?shipping_address%5Bzip%5D=${selectedZip}&shipping_address%5Bcountry%5D=${selectedCountry}&shipping_address%5Bprovince%5D=${selectedProvince}`
  )
    .then((response) => {
      if (response.status === 400) {
        // if there is rate calculation error
        return response.statusText;
      } else {
        return response.json();
      }
    })
    .then((data) => {
      if (data !== null && data !== "Bad Request") {
        // when a shipping rate is available update price in text
        const currencySymbol =
          data.shipping_rates[0].currency === "EUR"
            ? "€"
            : data.shipping_rates[0].currency;

        const shippingPriceFormatted =
          currencySymbol +
          " " +
          parseFloat(data.shipping_rates[0].price).toLocaleString("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

        shippingPriceTag.dataset.shippingCost =
          data.shipping_rates[0].price * 100;

        shippingPriceTag.innerHTML = shippingPriceFormatted;

        // show the shipping cost box and hide the loader
        loadingImageWrapper.style.display = "none";

        if (data.shipping_rates[0].price == 0.0) {
          document
            .querySelector(".js-free-shipping")
            .classList.remove("hidden");
        } else {
          document
            .querySelector(".js-default-shipping")
            .classList.remove("hidden");
        }

        // if the current page is the cart page execute totals calculation
        if (window.location.pathname.includes("cart")) {
          document.querySelector(".template-cart") && calculateTotals();
        }
      } else if (data === "Bad Request") {
        loadingImageWrapper.style.display = "none";
        document
          .querySelector(".js-default-shipping")
          .classList.remove("hidden");
      } else {
        // if shipping rate ist not available try again
        console.log("Shipping rate not ready");
        setTimeout(getShippingRates(), 500);
      }
    });
};

// function to proof shipping cost
// function is also called in theme.js on line 8255
// to update shipping rates after adding a product to cart
export async function proofShippingCost() {
  // show loading icon and hide shipping info blocks
  loadingImageWrapper.style.display = "block";
  errorWrapper.style.display = "none";
  shippingInfoTags.forEach(
    (el) => !el.classList.contains("hidden") && el.classList.add("hidden")
  );

  // get shipping and cart info
  const shipping = await prepareShippingRates();

  // if no shipping calculation is possible and no items
  // are in the cart display free shipping info
  if (shipping === "noshipping" && selectedCountry === "Germany") {
    loadingImageWrapper.style.display = "none";
    document.querySelector(".js-free-shipping").classList.remove("hidden");
  } else if (shipping === "noshipping" && selectedCountry !== "Germany") {
    loadingImageWrapper.style.display = "none";
    document.querySelector(".js-default-shipping").classList.remove("hidden");
  }
}

// load shipping rates on page load
proofShippingCost();
